import request from "@/request";
import {
  CategoryType,
  RobotBannerType,
  QuestionTagType,
  TagTypeEnum,
  RobotAIKeywordItem,
  QuestionType,
} from "@/app/types/typeConfig/chatQuestion";
// import { QuestionType } from "@/app/types/typeConfig/chatQuestion";
// import { ReportPropsTypes } from './report';

const prefix = "/gw/robot";

export interface RequestCommonParamsProps {
  language: string;
  [key: string]: unknown;
}

export const queryCategoryList = async (params: RequestCommonParamsProps) => {
  try {
    const dataForm: CategoryType[] = await request.get(
      `${prefix}/front/category/list`,
      { params },
    );
    return Promise.resolve(dataForm);
  } catch (err) {
    return Promise.reject(err);
  }
};

interface QueryTagListProps {
  type: TagTypeEnum;
  [key: string]: unknown;
}
export const queryTagList = async (params: QueryTagListProps) => {
  try {
    const dataForm: QuestionTagType[] = await request.get(
      `${prefix}/knowledge/tag/list`,
      { params },
    );
    return Promise.resolve(dataForm);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const queryAIKeyList = async (params: QueryTagListProps) => {
  try {
    const dataForm: RobotAIKeywordItem[] = await request.get(
      `${prefix}/ai/key/list`,
      { params },
    );
    return Promise.resolve(dataForm);
  } catch (err) {
    return Promise.reject(err);
  }
};

interface BannerParamsProps {
  languageCode: string;
  [key: string]: unknown;
}
export const queryBannerList = async (params: BannerParamsProps) => {
  try {
    const res: RobotBannerType[] = await request.get(`${prefix}/banner/list`, {
      params,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};

export interface FuzzyMatchingProblemProps {
  content: string;
  language: string;
  [key: string]: unknown;
}

export const handleFuzzyMatchingProblem = async (
  params: FuzzyMatchingProblemProps,
) => {
  try {
    const data: QuestionType[] = await request.post(
      `${prefix}/front/fuzzy`,
      params,
    );
    return Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
